import { createContext } from "react";
const chartContext = createContext()

export default chartContext;


